var _style, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCloseWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st1{fill:none;stroke:#fafafa;stroke-miterlimit:10}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "home_btn_live_close_background",
    fill: "none",
    d: "M4 4h16v16H4z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_close"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_3",
    className: "st1",
    d: "M4.5 4.5l15 15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_3-2",
    className: "st1",
    d: "M19.5 4.5l-15 15"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCloseWhite);
export default __webpack_public_path__ + "static/media/ic_close_white.85616b53e4f854fced6803315c84fc97.svg";
export { ForwardRef as ReactComponent };